(function flexible (window, document) {
    let docEl = document.documentElement
    let dpr = window.devicePixelRatio || 1

    function setBodyFontSize () {
        if (document.body) {
            // document.body.style.fontSize = (12 * dpr) + 'px'
            document.body.style.fontSize = 12 + 'px'
        } else {
            document.addEventListener('DOMContentLoaded', setBodyFontSize)
        }
    }

    setBodyFontSize()

    function setRemUnit () {
        let rem = docEl.clientWidth / 10
        let fontTrueSize
        docEl.style.fontSize = rem + 'px'
        if (docEl.currentStyle) {
            docEl.currentStyle.fontSize.replace(/[^\-?\d.]/g, '')
        } else {
            window.getComputedStyle(docEl, null).fontSize.replace(/[^\-?\d.]/g, '')
        }
        if (rem !== fontTrueSize) {
            docEl.style.fontSize = rem * (rem / parseFloat(fontTrueSize)) + 'px'
        }
    }

    setRemUnit()

    // reset rem unit on page resize
    window.addEventListener('resize', setRemUnit)
    window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            setRemUnit()
        }
    })

    // detect 0.5px supports
    if (dpr >= 2) {
        let fakeBody = document.createElement('body')
        let testElement = document.createElement('div')
        testElement.style.border = '.5px solid transparent'
        fakeBody.appendChild(testElement)
        docEl.appendChild(fakeBody)
        if (testElement.offsetHeight === 1) {
            docEl.classList.add('hairlines')
        }
        docEl.removeChild(fakeBody)
    }
}(window, document))



// WEBPACK FOOTER //
// ./src/assets/js/flexible.js